export default "__VITE_ASSET__2fbc0180__"